(function(){
  if(window.__tokeWishBound) return; window.__tokeWishBound=true;
  var KEY='toke_wishlist';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY))||[]; }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function has(id){ return read().some(function(x){ return String(x.id)===String(id); }); }
  function kl(event, item){
    try{
      var q = window._learnq || (window._learnq = []);
      q.push(['track', event, { ProductID:item.id, ProductName:item.title, Brand:item.vendor, URL:location.origin+item.url, ImageURL:item.img, Price:item.price }]);
    }catch(e){}
  }
  function updateCount(){
    var n=read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function(el){ el.textContent=n; if(n>0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); } });
  }
  function updateButtons(){
    document.querySelectorAll('.toke-wish').forEach(function(b){
      var saved=has(b.getAttribute('data-wid'));
      b.classList.toggle('is-saved', saved);
      b.setAttribute('aria-pressed', saved?'true':'false');
      var lbl=b.querySelector('[data-wish-label]');
      if(lbl){ lbl.textContent = saved ? 'En favoritos' : 'Guardar en favoritos'; }
    });
  }
  function toggle(b){
    var id=b.getAttribute('data-wid'); if(!id) return;
    var arr=read(); var idx=-1;
    for(var i=0;i<arr.length;i++){ if(String(arr[i].id)===String(id)){ idx=i; break; } }
    if(idx>-1){ arr.splice(idx,1); write(arr); }
    else {
      var item={ id:id, handle:b.getAttribute('data-handle'), title:b.getAttribute('data-title'), vendor:b.getAttribute('data-vendor'), img:b.getAttribute('data-img'), url:b.getAttribute('data-url'), price:b.getAttribute('data-price') };
      arr.push(item); write(arr); kl('Añadido a favoritos', item);
    }
    updateButtons(); updateCount(); renderPage();
  }
  function renderPage(){
    var grid=document.querySelector('[data-wishlist-grid]'); if(!grid) return;
    var arr=read(); var empty=document.querySelector('[data-wishlist-empty]');
    if(!arr.length){ grid.innerHTML=''; if(empty) empty.hidden=false; return; }
    if(empty) empty.hidden=true;
    grid.innerHTML = arr.map(function(it){
      var safeTitle=(it.title||'').replace(/"/g,'');
      return '<div class="tc-card"><button class="tc-card__rm" data-wremove="'+it.id+'" aria-label="Quitar de favoritos">&times;</button>'+
        '<a class="tc-card__media" href="'+it.url+'"><img class="tc-card__img" src="'+(it.img||'')+'" alt="'+safeTitle+'"></a>'+
        (it.vendor?'<p class="tc-card__brand">'+it.vendor+'</p>':'')+
        '<a class="tc-card__title" href="'+it.url+'">'+(it.title||'')+'</a>'+
        '<p class="tc-card__price">'+(it.price||'')+'</p>'+
        '<div class="tc-card__cta"><button type="button" class="tc-card__btn" data-wadd="'+(it.handle||'')+'" data-wurl="'+it.url+'">Añadir a la cesta</button></div>'+
        '</div>';
    }).join('');
  }
  function addToCart(btn){
    var handle=btn.getAttribute('data-wadd');
    var url=btn.getAttribute('data-wurl');
    if(!handle){ if(url) location.href=url; return; }
    var original=btn.textContent;
    btn.disabled=true; btn.textContent='Añadiendo…';
    fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(p){
        var vs=p.variants||[];
        if(vs.length>1){ location.href=url||('/products/'+handle); return null; }
        var v=vs.filter(function(x){return x.available;})[0];
        if(!v){ btn.textContent='Agotado'; setTimeout(function(){ btn.textContent=original; btn.disabled=false; },1600); return null; }
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});
      })
      .then(function(res){
        if(!res) return;
        btn.textContent='¡Añadido!';
        document.dispatchEvent(new CustomEvent('cart:update'));
        try{
          var d=document.querySelector('cart-drawer-component');
          if(d && typeof d.open==='function'){ d.open(); }
        }catch(e){}
        setTimeout(function(){ btn.textContent=original; btn.disabled=false; },1800);
      })
      .catch(function(){ btn.textContent=original; btn.disabled=false; if(url) location.href=url; });
  }
  document.addEventListener('click', function(e){
    var add=e.target.closest ? e.target.closest('[data-wadd]') : null;
    if(add){ e.preventDefault(); addToCart(add); return; }
    var b=e.target.closest ? e.target.closest('.toke-wish') : null;
    if(b){ e.preventDefault(); toggle(b); return; }
    var r=e.target.closest ? e.target.closest('[data-wremove]') : null;
    if(r){ e.preventDefault(); var id=r.getAttribute('data-wremove'); write(read().filter(function(x){return String(x.id)!==String(id);})); updateButtons(); updateCount(); renderPage(); }
  });
  function init(){ updateButtons(); updateCount(); renderPage(); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  setTimeout(init, 500);
})();
